import { useNavigation } from "@react-navigation/native";
import { TextInput02 } from "@src/components/textinput";
import { useAuthService } from "@src/ducks/hooks";
import { NavigationScreenProps } from "@src/navigators/NavigatorTypes";
import useOrientationHelper from "@src/utils/orientation-helper";
import _ from "lodash";
import React, { useState } from "react";
import { Text, View } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import ActionButton from "./action-button";
import ErrorView from "./error";
import GoogleButton from "./google-button";
import Forgot from "./remember-me";
import useStyles from "./styles.css";
import UnawaProduct from "./unawaProduct";
import { gtag } from 'ga-gtag';
import { MicrosoftSignInButton } from "./microsoft-button";

interface ErrorProps {
  email: string;
  password: string;
}

const ErrorValue = {
  email: "",
  password: "",
};

const Login = () => {
  const styles = useStyles();
  const errorRef = React.useRef<any>(null);
  const isLandScape = useOrientationHelper();
  const [error, setError] = useState<ErrorProps>(ErrorValue);
  const navigation = useNavigation<NavigationScreenProps<"Home">>();
  const { generatedOTP, loginInput, setLoginInput, onSignin, 
    isLoading, onResetLoading } = useAuthService();
  const onSignUp = () => navigation.navigate("Signup");

  const onChangeInput = (type: string) => (value: any) => {
    setLoginInput({ type, value });
    setError({} as ErrorProps);
    errorRef.current?.onClear();
  };

  const onSigningIn = () => {
    const newError: any = {};
    if (!loginInput.email) {
      newError.email = "Email is required.";
    }
    if (!loginInput.password) {
      newError.password = "Password is required.";
    }

    setError(newError);

    if (_.isEmpty(newError)) {
      onSignin(loginInput);
    }
  };

  const onSignInWithFaceID = () => {
    const newError: any = {};
    if (!loginInput.email) {
      newError.email = "Email is required.";
    }

    setError(newError);

    if (_.isEmpty(newError)) {
      navigation.navigate("SignInWithFaceID");
    }
  };

  const handleEnterKeyPress = (e: any) => { 
    if (e.key === "Enter") { 
      onSigningIn(); 
    }
  };

  React.useEffect(() => {
    gtag('event', 'login', { 'method': 'Login Screen' });
    onResetLoading();
    window.addEventListener("keypress", handleEnterKeyPress);

    return () => {
      window.removeEventListener("keypress", handleEnterKeyPress);
    };
  }, []);

  React.useEffect(() => {
    if (generatedOTP?.updatedAt) {
      navigation.navigate("SigninOtp")
    }
  }, [generatedOTP])

  return (
    <View style={styles.v_login_landscape} >
      <View style={styles.scrollview}>
        <View style={styles.v_height_top_landscape} />
        <View style={styles.signInCenter}>
        <Text 
            style={[
              styles.txtNote3, 
              loginInput.inviteToken ? styles.txtNote3InviteToken : null
            ]}
          >
            {loginInput.inviteToken ? "Let's Get You Started!" : "Welcome Back!" }</Text>
          <Text style={styles.txtNote4}>
            {loginInput.inviteToken && "Sign in to access your account"}
          </Text>
        </View>
        <ErrorView ref={errorRef} />
        <View style={styles.v_marginTop20}>
          <TextInput02
            value={loginInput.email}
            label="Email Address"
            labelStyle={styles.labelStyle}
            error={error.email}
            onChangeText={onChangeInput("email")}
            placeholder="Enter your email address"
            onKeyPress={handleEnterKeyPress}
          />
          <View style={{paddingBottom: 15}} />
          <TextInput02
            hasPassword
            value={loginInput.password}
            label="Password"
            labelStyle={styles.labelStyle}
            error={error.password}
            onChangeText={onChangeInput("password")}
            placeholder="⬤⬤⬤⬤⬤⬤⬤⬤⬤⬤"
            onKeyPress={handleEnterKeyPress}
          />
          <View style={{paddingBottom: 15}} />
          <Forgot 
            isCheck={loginInput?.rememberme}
            onCheck={() => onChangeInput("rememberme")(!loginInput?.rememberme)} />

          <View style={{paddingBottom: 5}} />
          <ActionButton
            email={loginInput.email}
            isLoading={isLoading}
            onSigningIn={onSigningIn}
            onSignInWithFaceID={onSignInWithFaceID}
          />  
          {!loginInput.inviteToken && (
              <>
                <View style={{flexDirection: "row", flex: 1, marginTop: 50, justifyContent: "center"}}>
                  <View style={styles.itemSeparator} />
                  <Text style={styles.txtNote5}> 
                    or Sign In With 
                  </Text>
                  <View style={styles.itemSeparator} />
                </View>
                <View style={{flexDirection: "row", alignContent: "center", alignItems:"center" ,alignSelf: "center"}}>
                  <GoogleButton />
                  <View style={{width: "25%"}}/>
                  <MicrosoftSignInButton />
                </View>
                <Text style={styles.t_signup}>
                  Don’t have an account yet?
                  <Text style={styles.t_signup_2} onPress={onSignUp}>
                    Register here
                  </Text>
                </Text>
              </>
            )}
        </View>
        {isLandScape ? null : <UnawaProduct />}
      </View>
    </View>
  );
};

export default Login;